import { MenuItem, Select, SelectProps } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CatalogProductStatus } from '../enums'

export type CatalogProductStatusSelectProps = Omit<
  SelectProps<CatalogProductStatus>,
  'children' | 'multiple'
>

export default function CatalogProductStatusSelect(props: CatalogProductStatusSelectProps) {
  const { t } = useTranslation('manufacturing')

  return (
    <Select {...props}>
      <MenuItem value={CatalogProductStatus.UNVERIFIED}>
        {t('CatalogProductStatus.unverified')}
      </MenuItem>
      <MenuItem value={CatalogProductStatus.VERIFIED}>
        {t('CatalogProductStatus.verified')}
      </MenuItem>
    </Select>
  )
}
